import { Empty, Flex, Skeleton, Typography } from "antd"
import React from "react"
import InfiniteScroll from "react-infinite-scroll-component"

import type {
  AlbumCreateData,
  AlbumListItem
} from "../../../../../../Album/types/album.types.ts"
import { AlbumCard } from "../AlbumCard/AlbumCard.tsx"
import {
  ALBUM_CARD_WITH,
  CreateAlbumCard
} from "../CreateAlbum/CreateAlbumCard.tsx"

export const { Text, Title } = Typography

interface ProjectAlbumsProps {
  albums: AlbumListItem[]
  createAllowed: boolean
  hasMore: boolean
  hasSearch: boolean
  isLoading?: boolean
  onLoadMore: () => void
  onViewAlbum?: (id: string) => void
  onCreateAlbum?: (data: AlbumCreateData) => Promise<void>
  userId: string
  deleteAllowed: boolean
  deleteForeignAllowed: boolean
  onDeleteClick: (albumId: string) => void
  editAllowed: boolean
  onEditClick: (albumId: string) => void
}

export const ProjectAlbums = ({
  albums,
  createAllowed,
  hasMore,
  hasSearch,
  isLoading,
  onLoadMore,
  onViewAlbum,
  onCreateAlbum,
  userId,
  deleteAllowed,
  deleteForeignAllowed,
  onDeleteClick,
  editAllowed,
  onEditClick
}: ProjectAlbumsProps) => {
  const isEmpty = !albums?.length && !isLoading

  if (isEmpty) {
    return (
      <div
        style={{
          gridTemplateColumns: `repeat(auto-fill, minmax(${ALBUM_CARD_WITH}px, 1fr))`
        }}
        className="grid gap-4 overflow-y-auto  tailwind-scroll overflow-x-hidden flex-1"
      >
        {createAllowed && !hasSearch && (
          <div className={"h-[290px]"}>
            <CreateAlbumCard onCreateAlbum={onCreateAlbum} />
          </div>
        )}

        <Flex align={"center"} justify={"center"} className={"h-[290px]"}>
          <Empty
            description={
              hasSearch
                ? "No albums found matching your search"
                : "No albums yet"
            }
          />
        </Flex>
      </div>
    )
  }

  return (
    <div
      id="albumsScrollableDiv"
      className="overflow-y-auto tailwind-scroll overflow-x-hidden flex-1"
    >
      <InfiniteScroll
        scrollableTarget="albumsScrollableDiv"
        dataLength={albums?.length ?? 0}
        next={onLoadMore}
        hasMore={hasMore}
        loader={
          <div
            style={{
              gridTemplateColumns: `repeat(auto-fill, minmax(${ALBUM_CARD_WITH}px, 1fr))`
            }}
            className="grid gap-4"
          >
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton.Node
                key={i}
                active
                style={{ width: "100%", height: "320px" }}
                className="w-full"
              />
            ))}
          </div>
        }
      >
        <div
          style={{
            gridTemplateColumns: `repeat(auto-fill, minmax(${ALBUM_CARD_WITH}px, 1fr))`
          }}
          className="grid gap-4"
        >
          {createAllowed && <CreateAlbumCard onCreateAlbum={onCreateAlbum} />}

          {albums.map((album) => (
            <AlbumCard
              key={album.id}
              album={album}
              onView={onViewAlbum}
              userId={userId}
              deleteAllowed={deleteAllowed}
              deleteForeignAllowed={deleteForeignAllowed}
              onDeleteClick={onDeleteClick}
              editAllowed={editAllowed}
              onEditClick={onEditClick}
            />
          ))}
        </div>
      </InfiniteScroll>
    </div>
  )
}
